import { NumberMaskProcessing } from './number';

export class CurrencyWithDecimalsMaskProcessing extends NumberMaskProcessing {
  protected fixedDecimals = 2;
  protected min = 0;
  protected prefix = '$';

  protected postProcessBlurred(): void {
    if (this.isDecimal) {
      // senitize trailing zeros and decimal points
      const processed = this.processed;
      let dotPos = processed.value.indexOf('.');

      if (typeof this.allowedDecimals === 'number' && this.allowedDecimals <= 0) {
        // integer case
        if (dotPos > -1) {
          processed.value = processed.value.substr(0, dotPos);
        }
      } else if (typeof this.fixedDecimals === 'number') {
        // fixed decimals
        if (processed.value) {
          if (dotPos < 0) {
            dotPos = processed.value.length;
            processed.value += '.';
          }
          while (processed.value.length <= dotPos + this.fixedDecimals) {
            processed.value += '0';
          }
        }
      } else if (dotPos > -1) {
        // non-fixed decimals with a decimal part
        while (processed.value.length >= dotPos && '0.'.indexOf(processed.value[processed.value.length - 1]) > -1) {
          processed.value = processed.value.substr(0, processed.value.length - 1); // remove trailing zeros and/or decimal point
        }
      }
      processed.value = `${this.removeLeadingZeros(processed.value)}`;
      // fix selection max if characaters got removed
      processed.selection[0] = Math.min(processed.selection[0], processed.value.length);
      processed.selection[1] = Math.min(processed.selection[1], processed.value.length);
    }
  }
  public removeLeadingZeros(num): string {
    num = num.replace(/[$]/g, '');
    // traverse the entire string
    for (let i = 0; i < num.length; i++) {
      // eslint-disable-next-line eqeqeq
      if (num.charAt(i) != '0') {
        const res = num.substr(i);
        return `${this.prefix}${res}`;
      }
    }
    return '';
  }
}
